import React from 'react';
import { Modal, FormInput, Button } from '@/components/ui';

export const CreateConversationModal = ({
  isOpen,
  onClose,
  newContact,
  setNewContact,
  handleCreateConversation,
  isCreating
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="New Conversation"
      size="md"
    >
      <form onSubmit={handleCreateConversation} className="flex flex-col gap-5">
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500 mb-2">Start a new WhatsApp conversation with a customer.</p>
        </div>
        <FormInput
          label="Customer Name"
          placeholder="e.g. John Doe"
          value={newContact.name}
          onChange={(e) => setNewContact({ ...newContact, name: e.target.value })}
        />
        <FormInput
          label="Phone Number"
          required
          type="tel"
          placeholder="+1234567890 (Include country code)"
          value={newContact.phone}
          onChange={(e) => setNewContact({ ...newContact, phone: e.target.value })}
        />
        <div className="flex gap-3 mt-4">
          <Button variant="outline" className="flex-1" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button type="submit" variant="orange" className="flex-1" loading={isCreating} disabled={isCreating}>
            Create Chat
          </Button>
        </div>
      </form>
    </Modal>
  );
};
